<template>
  <div class="magnetic-field-earth-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>磁南/北极 ≠ 地理南/北极</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Earth -->
          <circle cx="200" cy="120" r="60" fill="url(#earth-grad)" stroke="#444" />
          
          <!-- Geographic Axis -->
          <line x1="200" y1="30" x2="200" y2="210" stroke="#888" stroke-dasharray="4" />
          <text x="180" y="25" fill="#888" font-size="8">地理北极 N</text>

          <!-- Magnetic Axis (Tilted) -->
          <g :transform="`translate(200, 120) rotate(${declination})`">
             <line x1="0" y1="-70" x2="0" y2="70" stroke="#ff4757" stroke-width="2" />
             <rect x="-5" y="-70" width="10" height="70" fill="#ff4757" /> <!-- Magnetic South near Geo North -->
             <rect x="-5" y="0" width="10" height="70" fill="#fff" />
             <text x="10" y="-50" fill="#ff4757" font-size="10" font-weight="bold">S_m</text>
             
             <!-- Magnetic Field Lines -->
             <path v-for="i in 4" :key="'mf'+i" :d="calcFieldLine(i)" fill="none" stroke="rgba(255, 71, 87, 0.2)" stroke-width="1.5" />
          </g>

          <!-- Compass near Earth -->
          <g :transform="`translate(200, 200) rotate(${compassAngle})`">
             <path d="M 0,-15 L 5,0 L 0,15 L -5,0 Z" fill="#ff4757" />
             <circle r="2" fill="#fff" />
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>当前磁偏角: {{ declination }}°</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>调节磁轴偏移 (磁偏角)</label>
             <el-slider v-model="declination" :min="-20" :max="20" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>地球内部的熔融金属流动产生了巨大的磁场。地磁轴并不是与地球自转轴完全重合的，它们之间的夹角称为**磁偏角**。此外，目前的地理北极附近实际上是地磁的**南极**（S极），这就是为什么指南针的北极会指向北方。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EarthMagneticFieldViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      declination: 11
    }
  },
  computed: {
    compassAngle() {
      // Very simple mock: compass tracks the magnetic axis
      return this.declination;
    }
  },
  methods: {
    calcFieldLine(i) {
       let r = 50 + i * 30;
       return `M 0 -70 Q ${r} 0 0 70 Q ${-r} 0 0 -70`;
    }
  }
}
</script>

<style scoped lang="scss">
.magnetic-field-earth-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #001; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 111, 253, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
